import _throttle from 'lodash.throttle';
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';

const navBtn = document.querySelector('.c-header__toggle');
const nav = document.querySelector('.c-header__menu');
const header = document.querySelector('.c-header');
const targetElement = document.querySelector('.c-header__menu');
const body = document.querySelector('.c-article--page');
const html = document.documentElement;


const pageHeight = () => {
    const height = Math.max( body.scrollHeight, body.offsetHeight,
        html.clientHeight, html.scrollHeight, html.offsetHeight );
    document.documentElement.style.setProperty('--page-height', `${height}px`);
};

window.addEventListener('resize', () => requestAnimationFrame(pageHeight));
window.addEventListener('DOMContentLoaded', pageHeight, { once: true });


const navToggle = () => {
    nav.classList.toggle('is-active');
    navBtn.classList.toggle('is-active');
    header.classList.toggle('is-active');
    body.classList.toggle('is-active');

    if (header.classList.contains('is-active')) {
        disableBodyScroll(targetElement);
    } else {
        enableBodyScroll(targetElement);
    }
};

if (navBtn) {
    navBtn.onclick = navToggle;
}

const navItemAction = () => {
    const items = nav.querySelectorAll('a[href*="#"]');

    items.forEach(item => {
       item.addEventListener('click',() => {
           navToggle();
       })
    });
}
window.addEventListener('DOMContentLoaded', navItemAction, { once: true });

const headerHeight = () => {
    document.documentElement.style.setProperty('--header-height', `${header.clientHeight}px`);
};

window.addEventListener('resize', () => requestAnimationFrame(headerHeight));
window.addEventListener('DOMContentLoaded', headerHeight, { once: true });




let scrollObject = {};

const scroll = () => {
    const logo = document.querySelector('.c-header__logo-icon');

    if (header) {

        scrollObject = {
            y: window.pageYOffset,
        };
        // If you want to check distance
        if (scrollObject.y > 180) {
            header.classList.add('c-header--small');
        } else {
            header.classList.remove('c-header--small');
        }
    }
};

window.addEventListener('scroll', scroll);
